export function getBirthDayLists() {
  const currentYear = new Date().getFullYear();
  const yearList = Array.from({length: currentYear - 1970 + 1}, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  }));
  const monthList = Array.from({length: 12}, (_, i) => ({
    value: (i + 1).toString(),
    label: (i + 1).toString(),
  }));
  const dayList = Array.from({length: 31}, (_, i) => ({
    value: (i + 1).toString(),
    label: (i + 1).toString(),
  }));

  return {
    yearList,
    monthList,
    dayList,
  };
}
